import React from "react";
import { WizardStepHeaderProps } from "./types";
import { useTranslate } from "helpers";

const WizardStepHeader: React.FC<WizardStepHeaderProps> = ({
  stepNumber,
  title,
}) => {
  const { t } = useTranslate();

  return (
    <>
      {title && (
        <div className="px-4 pt-4 pb-3.5 flex items-center justify-between ">
          <h1 className="font-bold text-sm uppercase text-blue-500 ">
            {stepNumber}. {title}
          </h1>
        </div>
      )}
    </>
  );
};

export default WizardStepHeader;
